// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Gupter:wght@400&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contenedor_principal_per{
    display:flex;
    align-items: center; /* Centra horizontalmente */
    justify-content: center; /* Centra verticalmente */
    text-align: center;
}

.preguntas {
    font: 1.4em Gupter;
    display: flex;
    flex-direction: column;
    justify-content: center; /* Centra las columnas horizontalmente */
    align-items: center; /* Centra las filas verticalmente */
    border: double 7px white;
    background-color:#a2d1e0;
    margin-bottom: 20px;
    margin-top: 20px;
    border-radius: 20px;
    padding-top: 20px;
    padding-bottom: 20px;
}

.opcion {
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;
    justify-content: left;
    text-align: justify;
    align-items: left;
    margin-bottom: 20px;
}

.opcion input[type="radio"] {
    margin-right: 8px; /* Espacio entre el radio button y el texto */
}

.radiobutton {
    height: 20px;
    width: 20px;
    margin-left: 15px;
}

.verification {
    font-weight: bold;
    color: darkgreen;
    margin: 20px;
    padding: 20px;
    border-radius: 10px;
    border: double 7px #a2d1e0;
    font-weight: bold;
    background-color: rgba(148, 237, 141, 0.75);
}

.attention {
    font-weight: bold;
    color: darkorange;
}

.error {
    font-weight: bold;
    color: rgb(221, 30, 30);
    margin: 20px;
    padding: 20px;
    border-radius: 10px;
    border: double 7px #a2d1e0;
    font-weight: bold;
    background-color: rgba(229, 137, 137, 0.75);   
}

.verification2 {
    color: darkgreen;
}

.examenPregunta {
    background-color: white;
    margin: 20px;
    padding: 10px;
    border-radius: 20px;
    border: double 7px #a2d1e0;
}

.boldPalabras{
    font: 1.2em Gupter;
    font-weight: bold;
}

button.botonVerificar
{
    margin-top: 20px;
    color: white;
    background-color: rgb(170, 157, 152);
    padding: 10px;
    margin: 20px;
    border-radius: 20px;
    border: double 7px #a2d1e0;
    font-style: bold;
    cursor: pointer;
}

button.botonVerificar:not(:disabled):hover
{
    color: orange;
    background-color: greenyellow;
}

button.botonVerificar:disabled
{
    background-color: #cccccc; /* Color gris para indicar que está deshabilitado */
    color: #666666; /* Texto en color más tenue */
    cursor: not-allowed;
}

button.botonSiguiente:disabled
{
    background-color: #cccccc; /* Color gris para indicar que está deshabilitado */
    color: #666666; /* Texto en color más tenue */
    cursor: not-allowed;
}

button.botonSiguiente:not(:disabled):hover
{
    color: orange;
    background-color: greenyellow;
}

.botones {
    display: inline-flex;
    justify-content: center; /* Centra las columnas horizontalmente */
    align-items: center;
}

button.botonSiguiente
{
    margin: 20px;
    color: white;
    background-color: rgb(170, 157, 152);
    padding: 10px;
    border-radius: 20px;
    border: double 7px #a2d1e0;
    font-style: bold;
}

.aciertos{
    margin: 20px;
    padding: 20px;
    border-radius: 10px;
    border: double 7px #a2d1e0;
    font-weight: bold;
    background-color: rgba(255,255,255,0.75);   
}

.correcta {
    color: green;
    font-weight: bold;
}
.incorrecta {
    color: red;
}`, "",{"version":3,"sources":["webpack://./src/css/Ver_preguntas.css"],"names":[],"mappings":"AAEA;IACI,YAAY;IACZ,mBAAmB,EAAE,2BAA2B;IAChD,uBAAuB,EAAE,yBAAyB;IAClD,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,uBAAuB,EAAE,wCAAwC;IACjE,mBAAmB,EAAE,mCAAmC;IACxD,wBAAwB;IACxB,wBAAwB;IACxB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,eAAe;IACf,qBAAqB;IACrB,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB,EAAE,6CAA6C;AACpE;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,0BAA0B;IAC1B,iBAAiB;IACjB,2CAA2C;AAC/C;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,0BAA0B;IAC1B,iBAAiB;IACjB,2CAA2C;AAC/C;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;;IAEI,gBAAgB;IAChB,YAAY;IACZ,oCAAoC;IACpC,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,0BAA0B;IAC1B,gBAAgB;IAChB,eAAe;AACnB;;AAEA;;IAEI,aAAa;IACb,6BAA6B;AACjC;;AAEA;;IAEI,yBAAyB,EAAE,mDAAmD;IAC9E,cAAc,EAAE,6BAA6B;IAC7C,mBAAmB;AACvB;;AAEA;;IAEI,yBAAyB,EAAE,mDAAmD;IAC9E,cAAc,EAAE,6BAA6B;IAC7C,mBAAmB;AACvB;;AAEA;;IAEI,aAAa;IACb,6BAA6B;AACjC;;AAEA;IACI,oBAAoB;IACpB,uBAAuB,EAAE,wCAAwC;IACjE,mBAAmB;AACvB;;AAEA;;IAEI,YAAY;IACZ,YAAY;IACZ,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,0BAA0B;IAC1B,iBAAiB;IACjB,wCAAwC;AAC5C;;AAEA;IACI,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,UAAU;AACd","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Gupter:wght@400&display=swap\");\r\n\r\n.contenedor_principal_per{\r\n    display:flex;\r\n    align-items: center; /* Centra horizontalmente */\r\n    justify-content: center; /* Centra verticalmente */\r\n    text-align: center;\r\n}\r\n\r\n.preguntas {\r\n    font: 1.4em Gupter;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center; /* Centra las columnas horizontalmente */\r\n    align-items: center; /* Centra las filas verticalmente */\r\n    border: double 7px white;\r\n    background-color:#a2d1e0;\r\n    margin-bottom: 20px;\r\n    margin-top: 20px;\r\n    border-radius: 20px;\r\n    padding-top: 20px;\r\n    padding-bottom: 20px;\r\n}\r\n\r\n.opcion {\r\n    display: flex;\r\n    align-items: flex-start;\r\n    flex-wrap: wrap;\r\n    justify-content: left;\r\n    text-align: justify;\r\n    align-items: left;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.opcion input[type=\"radio\"] {\r\n    margin-right: 8px; /* Espacio entre el radio button y el texto */\r\n}\r\n\r\n.radiobutton {\r\n    height: 20px;\r\n    width: 20px;\r\n    margin-left: 15px;\r\n}\r\n\r\n.verification {\r\n    font-weight: bold;\r\n    color: darkgreen;\r\n    margin: 20px;\r\n    padding: 20px;\r\n    border-radius: 10px;\r\n    border: double 7px #a2d1e0;\r\n    font-weight: bold;\r\n    background-color: rgba(148, 237, 141, 0.75);\r\n}\r\n\r\n.attention {\r\n    font-weight: bold;\r\n    color: darkorange;\r\n}\r\n\r\n.error {\r\n    font-weight: bold;\r\n    color: rgb(221, 30, 30);\r\n    margin: 20px;\r\n    padding: 20px;\r\n    border-radius: 10px;\r\n    border: double 7px #a2d1e0;\r\n    font-weight: bold;\r\n    background-color: rgba(229, 137, 137, 0.75);   \r\n}\r\n\r\n.verification2 {\r\n    color: darkgreen;\r\n}\r\n\r\n.examenPregunta {\r\n    background-color: white;\r\n    margin: 20px;\r\n    padding: 10px;\r\n    border-radius: 20px;\r\n    border: double 7px #a2d1e0;\r\n}\r\n\r\n.boldPalabras{\r\n    font: 1.2em Gupter;\r\n    font-weight: bold;\r\n}\r\n\r\nbutton.botonVerificar\r\n{\r\n    margin-top: 20px;\r\n    color: white;\r\n    background-color: rgb(170, 157, 152);\r\n    padding: 10px;\r\n    margin: 20px;\r\n    border-radius: 20px;\r\n    border: double 7px #a2d1e0;\r\n    font-style: bold;\r\n    cursor: pointer;\r\n}\r\n\r\nbutton.botonVerificar:not(:disabled):hover\r\n{\r\n    color: orange;\r\n    background-color: greenyellow;\r\n}\r\n\r\nbutton.botonVerificar:disabled\r\n{\r\n    background-color: #cccccc; /* Color gris para indicar que está deshabilitado */\r\n    color: #666666; /* Texto en color más tenue */\r\n    cursor: not-allowed;\r\n}\r\n\r\nbutton.botonSiguiente:disabled\r\n{\r\n    background-color: #cccccc; /* Color gris para indicar que está deshabilitado */\r\n    color: #666666; /* Texto en color más tenue */\r\n    cursor: not-allowed;\r\n}\r\n\r\nbutton.botonSiguiente:not(:disabled):hover\r\n{\r\n    color: orange;\r\n    background-color: greenyellow;\r\n}\r\n\r\n.botones {\r\n    display: inline-flex;\r\n    justify-content: center; /* Centra las columnas horizontalmente */\r\n    align-items: center;\r\n}\r\n\r\nbutton.botonSiguiente\r\n{\r\n    margin: 20px;\r\n    color: white;\r\n    background-color: rgb(170, 157, 152);\r\n    padding: 10px;\r\n    border-radius: 20px;\r\n    border: double 7px #a2d1e0;\r\n    font-style: bold;\r\n}\r\n\r\n.aciertos{\r\n    margin: 20px;\r\n    padding: 20px;\r\n    border-radius: 10px;\r\n    border: double 7px #a2d1e0;\r\n    font-weight: bold;\r\n    background-color: rgba(255,255,255,0.75);   \r\n}\r\n\r\n.correcta {\r\n    color: green;\r\n    font-weight: bold;\r\n}\r\n.incorrecta {\r\n    color: red;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
